var $ = require('jquery')

module.exports = function whenCompontentExist(selector, context) {
  var dfd = new $.Deferred()
    , context = context || $('body')
    , element = context.find(selector)

  dfd[element.length ? 'resolve': 'reject']
    .apply(this, arguments)

  return dfd.promise()
}
